import create from 'zustand';

import { DEFAULT_MISSING_EMAIL, DEFAULT_USER_CURRENCY, LANG_ES } from '@/config/appConstants';
import { Appsumo, Capabilities, Me, UserInfo } from '@/types';

type MeHook = {
  me: Me;
  isSet: boolean;
  getMe: () => Me;
  setMe: (me: Me) => void;
  isMeSet: () => boolean;
  setUserInfo: (userInfo: UserInfo) => void;
  setCapabilities: (capabilities: Capabilities) => void;
};

const defaultUserInfo: UserInfo = {
  id: '',
  name: '',
  lastName: '',
  email: DEFAULT_MISSING_EMAIL,
  groupId: '',
  rolId: '',
  groupCreatedAt: '',
  language: LANG_ES,
  currency: DEFAULT_USER_CURRENCY,
};

const defaultAppsumo: Appsumo = {
  isAppsumo: false,
  canMakeAppsumoActions: false,
};

const defaultCapabilities: Capabilities = {
  isManualValidationEnabled: true,
  isBillingDetailsFilled: false,
  canBuySubscriptionProducts: false,
  canBuyProducts: false,
  apiAccessEnabled: false,
  appsumo: defaultAppsumo,
};

const defaultMe: Me = {
  userInfo: defaultUserInfo as UserInfo,
  capabilities: defaultCapabilities as Capabilities,
} as Me;

export const useMe = create<MeHook>((set, get) => ({
  me: defaultMe,
  isSet: false,
  getMe: (): Me => {
    return {
      userInfo: get().me.userInfo,
      capabilities: get().me.capabilities,
    };
  },

  setMe: (me: Me) => {
    if (me.userInfo === get().me?.userInfo && me.capabilities === get().me?.capabilities) return;
    set(() => ({
      isSet: true,
      me: me,
    }));
  },

  isMeSet: (): boolean => {
    return get().isSet;
  },

  setUserInfo: (userInfo: UserInfo) => {
    if (userInfo === get().me?.userInfo) return;
    const me = get().me;
    if (me) me.userInfo = userInfo;
    set(() => ({
      me: me,
    }));
  },

  setCapabilities: (capabilities: Capabilities) => {
    if (capabilities === get().me?.capabilities) return;
    const me = get().me;
    if (me) me.capabilities = capabilities;
    set(() => ({
      me: me,
    }));
  },
}));
